import { type NextBestAction } from '@post-office/confluence-next-best-action';
import {
	type BackendPlacementMessage,
	defaultMessageBackend,
	type FrontendPlacementMessage,
} from '@post-office/placement-common-v2';
import {
	type AnyBackendMessageStage,
	type AnyFrontendStage,
	type AnyPayload,
	type BackendSyncMessageStage,
	type CreatePlacementMessageConfig,
} from '@post-office/placement-common-v2/create-placement/types';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import type { TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import type { MessageTemplateContext } from '../../../index';

import { ConfluenceAgentsMcpNudgeBanner } from './components/confluence-agents-mcp-nudge-banner';

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(defaultMessageBackend);

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => void;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed, onSideNavClick }: MessageFrontendProps) => (
			<ConfluenceAgentsMcpNudgeBanner onDismiss={handleOnDismissed} onSetup={onSideNavClick} />
		),
	},
});
